export default {
    log: function log(_ref) {
        var category = _ref.category,
            eventName = _ref.eventName,
            payload = _ref.payload;

        var timestamp = new Date().toString();
        console.log(timestamp, category, eventName, payload);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-js/adapters/ConsoleLogAdapter.js
// module id = 918
// module chunks = 0